<ng-container *ngIf="!notDisplayNav">
  <ng-container *ngIf="isHomePage">
    <div class="mobile-nav-menu bg-black d-flex position-fixed flex-column d-lg-none">
      <!-- NAV BAR -->
      <div class="container">
        <div class="mobile-nav-bar-home bg-black d-flex justify-content-between">
          <a class="nav-item fw-bold brand p-1 ps-0" [routerLink]="['/']" routerLinkActive="router-link-active">
            <img class="home-logo" [src]="'images/home-logo.png' | contentAssetImage" draggable="false" />
          </a>
          <div class="right-nav-menu d-flex flex-row gap-3">
            <div class="notification-button-wrapper">
              <fgb-notification-button [size]="24" />
            </div>
            <button class="nav-item fw-bold navbar-toggler m-0 px-2" (click)="isCollapsed = !isCollapsed">
              <span class="icon material-icons font-size"> menu </span>
            </button>
          </div>
        </div>
      </div>

      <!-- NAV SCREEN -->
      <ng-container *ngIf="isCollapsed">
        <div class="mobile-nav-menu-dropdown">
          <div class="container">
            <div class="d-flex flex-column mobile-nav-menu-content">
              <!-- Close Button -->
              <button class="close-button position-absolute border-0" (click)="isCollapsed = !isCollapsed">
                <i class="material-icons close-btn">close</i>
              </button>

              <!-- Club Logo -->
              <div class="d-flex align-items-center justify-content-start p-1 ps-0 brand-logo">
                <img class="brand" [src]="'images/logo.png' | contentAssetImage" draggable="false" />
              </div>

              <div class="member-card mb-2 bg-primary rounded">
                <div class="modal-content d-flex gap-2">
                  <div class="modal-header w-100 d-flex align-items-center justify-content-between mt-3">
                    <div class="header-left">
                      <div class="card-name text-white text-uppercase font-size-18 font-page-heading"
                        *ngIf="memberDetails$ | async as memberDetails">
                        {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
                      </div>
                      <div class="account-num-header text-white" *ngIf="card$ | async as memberCard">
                        <span class="font-size-14">{{ 'barcode.memberid' | translate }} </span>
                        <span class="font-size-14">{{ memberCard.ExternalRefNumber }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="add-card mb-3 mt-2">
                  <fgb-add-card-payment />
                </div>
              </div>

              <!-- Nav Links -->
              <ul class="nav-list" role="list">
                <li>
                  <a class="nav-link" [routerLink]="['/']" [routerLinkActive]="'active'"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span class="material-icons nav-icon" aria-hidden="true">home</span>
                    <span class="nav-label">{{ 'nav.home' | translate }}</span>
                  </a>
                </li>
                <li>
                  <a class="nav-link" [routerLink]="['/account']" [routerLinkActive]="'active'"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span class="material-icons nav-icon" aria-hidden="true">account_circle</span>
                    <span class="nav-label">{{ 'nav.account' | translate }}</span>
                  </a>
                </li>

                <li>
                  <a class="nav-link" [routerLink]="['/rewards/wallet']" [routerLinkActive]="'active'"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span class="material-icons nav-icon" aria-hidden="true">qr_code</span>
                    <span class="nav-label">{{ 'nav.wallet' | translate }}</span>
                  </a>
                </li>

                <li>
                  <a class="nav-link" [routerLink]="['/rewards']" [routerLinkActive]="'active'"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span class="material-icons nav-icon" aria-hidden="true">card_giftcard</span>
                    <span class="nav-label">{{ 'nav.rewards' | translate }}</span>
                  </a>
                </li>

                <li>
                  <a class="nav-link" [routerLink]="['/challenges']" [routerLinkActive]="'active'"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span class="material-icons nav-icon" aria-hidden="true">emoji_events</span>
                    <span class="nav-label">{{ 'nav.challenges' | translate }}</span>
                  </a>
                </li>

                <li>
                  <a class="nav-link" [routerLink]="['/ecash']" [routerLinkActive]="'active'"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span class="material-icons nav-icon" aria-hidden="true">credit_card</span>
                    <span class="nav-label">{{ 'nav.payment' | translate }}</span>
                  </a>
                </li>

                <li>
                  <a class="nav-link" [routerLink]="['/earn']" [routerLinkActive]="'active'"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span class="material-icons nav-icon" aria-hidden="true">star</span>
                    <span class="nav-label">{{ 'nav.earn' | translate }}</span>
                  </a>
                </li>
                <!-- Help accordion -->
                <li class="nav-accordion">
                  <button class="nav-link nav-accordion-toggle" (click)="isHelpOpen = !isHelpOpen"
                    [attr.aria-expanded]="isHelpOpen" aria-controls="help-submenu">
                    <span class="material-icons nav-icon" aria-hidden="true">info</span>
                    <span class="nav-label">{{ 'nav.help' | translate }}</span>              
                      <span class="material-icons accordion-chevron" [class.open]="isHelpOpen" aria-hidden="true">{{ isHelpOpen ? 'expand_less' : 'chevron_right' }}</span>
                  </button>
                  <ul id="help-submenu" class="nav-submenu" [ngbCollapse]="!isHelpOpen" role="list">
                    <li>
                      <a class="nav-sublink" [routerLink]="['/terms']" [routerLinkActive]="'active'">
                        {{ 'nav.terms' | translate }}
                      </a>
                    </li>
                    <li>
                      <a class="nav-sublink" [routerLink]="['/faq']" [routerLinkActive]="'active'">
                        {{ 'nav.faq' | translate }}
                      </a>
                    </li>
                    <li>
                      <a class="nav-sublink" [routerLink]="['/contact']" [routerLinkActive]="'active'">
                        {{ 'nav.contact.us' | translate }}
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a class="nav-link" (click)="logout()" [routerLinkActive]="'active'"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span class="material-icons nav-icon" aria-hidden="true">logout</span>
                    <span class="nav-label">{{ 'nav.log.out' | translate }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="isWallet || isTertiary">
    <div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
      <div class="container" [ngClass]="isWallet && 'pt-1'"
        [ngClass]="(isWalletItem || isClaimedPage || isCampaignPage || isTertiary || isCheckOut) && 'pb-5'">
        <div class="mobile-nav-bar p-relative d-flex justify-content-start align-items-center w-100">
          <a *ngIf="isRootRoute(); else useRouterLink" href="/"><span
              class="material-symbols-outlined text-white d-flex align-items-center"> arrow_back_ios </span></a>
          <ng-template #useRouterLink>
            <a [routerLink]="getDynamicRoute()"><span
                class="material-symbols-outlined text-white d-flex align-items-center"> arrow_back_ios </span></a>
          </ng-template>

          <div class="reward-tertiary-title font-page-heading font-size-18 text-uppercase text-white">{{ title }}</div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!isWallet && !isTertiary && !isHomePage">
    <div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
      <div class="container">
        <div
          class="mobile-nav-bar mobile-nav-point p-relative d-flex justify-content-between align-items-center w-100 pb-5">
          <div class="left-bar d-flex flex-row gap-2">
            <a [href]="isPurchaseSuccessPage ? '/rewards' : ''"><span
                class="material-symbols-outlined text-white d-flex align-items-center"> arrow_back_ios </span></a>

            <div class="title font-page-heading font-size-20 text-uppercase text-white">{{ title }}</div>
          </div>

          <div class="right-bar d-flex flex-row gap-2">
            <div class="right-bar-item" *ngIf="pointsBalance$">
              <span class="icons material-icons font-size-18" aria-hidden="true">loyalty</span>
              <div class="font-size-14 point-value">
                {{ pointsBalance$ | async }}
              </div>
            </div>

            <div class="right-bar-item p-2" routerLink="/rewards/wallet">
              <span class="icons material-symbols-outlined"> qr_code_2 </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>